import * as _ from 'underscore';

import { DateHelpers } from '../helpers/DateHelpers';

export module MapperHelper {

  export function toNumber(value: any): number {

    // Return numbers and null/undefined without conversion
    if (_.isNumber(value) || _.isNull(value) || _.isUndefined(value))
      return value;

    // Otherwise, attempt to parse the value
    return parseInt(value, 10);
  }

  export function toDate(value: string): Date {
    return DateHelpers.fromISOString(value);
  }

  export function arrayToMap(values: string[]): _.Dictionary<string> {
    return _.object<_.Dictionary<string>>(values, values);
  }

  export function sortTags(tags: string[]) {
    return _(tags).sortBy((tagName: string) => tagName.toLowerCase());
  }

}
